var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$vuetify.breakpoint.mdAndUp ? 'footer desktop' : 'footer mobile'},[_vm._m(0),_c('div',{staticClass:"copyright"},[_vm._v("© 2025 MAYACREW. All rights reserved.")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer-container"},[_c('div',{staticClass:"footer-title"},[_vm._v("MAYACREW")]),_c('div',{staticClass:"footer-subtitle"},[_vm._v("글로벌 인플루언서 마케팅의 새로운 기준")])])
}]

export { render, staticRenderFns }